import { Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow, } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import OperationReportService from "../../../Services/Reports/OperationReportService";
import Home from "../../home/Home";
import { getDate } from "../../Utils/Common";
import Snackbar from '../../Snacbar'
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  backgroundColor: "white",
}));

function DocumentationEmployeeReport() {
  const mystyle = {
    border: " 1px solid black",
    width: "12rem",
    marginRight: "1rem",
    fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",
    fontFamily: 'Times New Roman',
  };
  ///
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [showProcs, setshowProcs] = useState(false)
  const [exportExcelProcs, setexportExcelProcs] = useState(false)
  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [loading, setloading] = useState(false)
  const [FilteredDetails, setFilteredDetails] = useState([]);
  const [docEmpValues, setdocEmpValues] = useState({
    from: getDate(),
    to: getDate(),
    branch: '-1',
    empnm: '-1',
  });
  const fromhandlechange = (e) => {
    setdocEmpValues({ ...docEmpValues, from: e.target.value })
  };
  const tohandlechange = (e) => {
    setdocEmpValues({ ...docEmpValues, to: e.target.value })
  };
  const branchhandlechange = (e) => {
    setdocEmpValues({ ...docEmpValues, branch: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const empnmhandlechange = (e) => {
    setdocEmpValues({ ...docEmpValues, empnm: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  //error message
  const handleClose = () => {
    setOpen(false)
  }
  ///getfunctions
  const getfunctions = () => {
    OperationReportService.selectBranchDetails().then(res => {
      setdetails1(res.data);
    })
    OperationReportService.getEmployeeDetails().then(res => {
      setdetails2(res.data);
    })
  }
  // btnOperations
  const showBtnOperations = () => {
    setshowProcs(true)
    setloading(true)
    setPage(0)
    var employeeId, regionalId = '';
    if (docEmpValues.empnm === 'ALL') {
      employeeId = '-1'
    } else {
      employeeId = docEmpValues.empnm;
    }
    if (docEmpValues.branch === 'ALL') {
      regionalId = '-1'
    } else {
      regionalId = docEmpValues.branch;
    }
    let details = { fromDate: docEmpValues.from, toDate: docEmpValues.to, employeeId: employeeId, regionalId: regionalId, flag: 1 };
    OperationReportService.getDocumentationEmployeeReport(details).then(res => {
      const data = res.data;
      const details = data.map((item) => item)
      if (details[0] === [] || !details[0]) {
        setMessage('No Record Found');
        setseverit('warning')
        setOpen(true)
        setshowProcs(false)
        setloading(false)
      } else {
        setdetails3(res.data);
        setFilteredDetails(res.data);
        setshowProcs(false)
        setloading(false)
      }
    })
  }
  const exportExcelBtn = () => {
    setexportExcelProcs(true)
    if (!details3[0]) {
      setMessage('No Record Found')
      setseverit('warning')
      setOpen(true)
      setexportExcelProcs(false)
    } else {
      var tableContent, contenall = '';
      for (let i = 0; i < details3.length; i++) {
        if (details3[i].operationType !== '') {
          tableContent = details3[i].operationType + "!"
        } else {
          tableContent += '   !'
        }
        if (details3[i].consignmentNumber !== '') {
          tableContent += details3[i].consignmentNumber + "!"
        }
        else {
          tableContent += '  !';
        }
        if (details3[i].status !== '') {
          tableContent += details3[i].status + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].regionalName !== '') {
          tableContent += details3[i].regionalName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].customPointName !== '') {
          tableContent += details3[i].customPointName + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].importer_name !== '') {
          tableContent += details3[i].importer_name + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].forwarder_name !== '') {
          tableContent += details3[i].forwarder_name + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].mawbNo !== '') {
          tableContent += details3[i].mawbNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].mawb_date !== '') {
          tableContent += details3[i].mawb_date + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].hawb_no !== '') {
          tableContent += details3[i].hawb_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].hawbDate !== '') {
          tableContent += details3[i].hawbDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].IgmNo !== '') {
          tableContent += details3[i].igmNo + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].igmDate !== '') {
          tableContent += details3[i].igmDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totalPcs !== '') {
          tableContent += details3[i].totalPcs + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totalWeight !== '') {
          tableContent += details3[i].totalWeight + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].beType !== '') {
          tableContent += details3[i].beType + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].boe_no !== '') {
          tableContent += details3[i].boe_no + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].boe_date !== '') {
          tableContent += details3[i].boe_date + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totalInvoice !== '') {
          tableContent += details3[i].totalInvoice + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceValue !== '') {
          tableContent += details3[i].invoiceValue + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].totalCarton !== '') {
          tableContent += details3[i].totalCarton + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].assbleValue !== '') {
          tableContent += details3[i].assbleValue + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].dutyAmount !== '') {
          tableContent += details3[i].dutyAmount + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].drawbackAmt !== '') {
          tableContent += details3[i].drawbackAmt + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].currency_code !== '') {
          tableContent += details3[i].currency_code + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].jobDate !== '') {
          tableContent += details3[i].jobDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].jobBy !== '') {
          tableContent += details3[i].jobBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceDate !== '') {
          tableContent += details3[i].invoiceDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].invoiceBy !== '') {
          tableContent += details3[i].invoiceBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].itemDate !== '') {
          tableContent += details3[i].itemDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].itemBy !== '') {
          tableContent += details3[i].itemBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].clPrintDate !== '') {
          tableContent += details3[i].clPrintDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].clPrintBy !== '') {
          tableContent += details3[i].clPrintBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].clApprovalDate !== '') {
          tableContent += details3[i].clApprovalDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].clApprovalBy !== '') {
          tableContent += details3[i].clApprovalBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].clSendDate !== '') {
          tableContent += details3[i].clSendDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].clSendBy !== '') {
          tableContent += details3[i].clSendBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].clVerifyDate !== '') {
          tableContent += details3[i].clVerifyDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].clVerifyBy !== '') {
          tableContent += details3[i].clVerifyBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].flatGenDate !== '') {
          tableContent += details3[i].flatGenDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].flatGenBy !== '') {
          tableContent += details3[i].flatGenBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].flatIcegateDate !== '') {
          tableContent += details3[i].flatIcegateDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].flatIcegateBy !== '') {
          tableContent += details3[i].flatIcegateBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].beUpdatedDate !== '') {
          tableContent += details3[i].beUpdatedDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].beUpdatedBy !== '') {
          tableContent += details3[i].beUpdatedBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].dutyDate !== '') {
          tableContent += details3[i].dutyDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].dutyBy !== '') {
          tableContent += details3[i].dutyBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].tspDate !== '') {
          tableContent += details3[i].tspDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].tspBy !== '') {
          tableContent += details3[i].tspBy + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].clearanceDate !== '') {
          tableContent += details3[i].clearanceDate + "!"
        } else {
          tableContent += '  !';
        }
        if (details3[i].clearanceBy !== '') {
          tableContent += details3[i].clearanceBy + "#"
        } else {
          tableContent += '  #';
        }
        contenall += tableContent;
      }
      // console.log('contenall => '+JSON.stringify(contenall))
      let details = {
        headerName: "3,0,DOCUMENTATION EMPLOYEE REPORT", headerDetails: "1,1,FROM DATE : " + docEmpValues.from + "/4,1,TO DATE : " + docEmpValues.to,
        tableHeader: "0,3,Sl.No/1,3,Operation/2,3,Job No/3,3,Job Status/4,3,Branch/5,3,Edi Location/6,3,Customer Name/7,3,Forwarder Name/8,3,MAWB_MBL No/9,3,MAWB_MBL Date/10,3,HAWB_HBL No/11,3,HAWB_HBL Date/12,3,IGM No/13,3,IGM Date/14,3,Total Pcs/15,3,Total Weight/16,3,BE_SB Type/17,3,BE_SB No/18,3,BE_SB Date/19,3,No of Invoice/20,3,Total Invoice Value/21,3,No of Item/22,3,Asseseble Value/23,3,Duty Amount/24,3,Drawback Amount/25,3,Invoice Currency/26,3,Job Date/27,3,Job By/28,3,Invoice Date/29,3,Invoice By/30,3,Item Date/31,3,Item By/32,3,Checklist Print Date/33,3,Checklist Print By/34,3,Checklist Approval Date/35,3,Checklist Approval By/36,3,Checklist Send Date/37,3,Checklist Send By/38,3,Checklist Verified Date/39,3,Checklist Verified By/40,3,FlatFile GenerationDate/41,3,FlatFile GenerationBy/42,3,FlatFile ICEGATE UploadDate/43,3,FlatFile ICEGATE UploadBy/44,3,BE_SB No UpdatedDate/45,3,BE_SB No Updated By/46,3,Duty Payment Date/47,3,Duty Payment By/48,3,TSP Payment Date/49,3,TSP Payment By/50,3,Clearance Date/51,3,Clearance By",
        tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "Document", totalNumberOfColumn: 52, tableContent: contenall.substring(0, contenall.length - 1),
      }
      OperationReportService.Excelwrite(details).then((res) => {
        const filename = res.data.message;
        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

      })
    }
    setexportExcelProcs(false)
  }
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getfunctions();
  }, []);

  //table search

  const jobNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { jobNoOnchange(e.target.value) }} />
  }
  const ediLocSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { ediLocOnchange(e.target.value) }} />
  }
  const cusNmSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { cusNmOnchange(e.target.value) }} />
  }
  const igmNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
      onChange={(e) => { igmNoOnchange(e.target.value) }} />
  }
  //
  const jobNoOnchange = (searchedVal) => {
    const filteredValue = details3.filter((trns) => {
      return trns.consignmentNumber.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredValue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredValue)
    }
  }
  const ediLocOnchange = (searchedVal) => {
    const filteredValue = details3.filter((trns) => {
      return trns.customPointName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredValue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredValue)
    }
  }
  const cusNmOnchange = (searchedVal) => {
    const filteredValue = details3.filter((trns) => {
      return trns.importer_name.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredValue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredValue)
    }
  }
  const igmNoOnchange = (searchedVal) => {
    const filteredValue = details3.filter((trns) => {
      return trns.igmNo.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredValue.length < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredValue)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  return (
    <div>
      <Home />
      <div style={{ paddingLeft: '100px' }}>
        <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <ItemPap>
            <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '25px', marginTop: '1%', marginBottom: '1%', }}>
              <center>DOCUMENTATION EMPLOYEE WISE REPORT</center></div>
            <Row>
              <Col><center>
                <label style={mystyle1}>From Date</label>
                <Form.Control size="sm" type="date" style={mystyle} value={docEmpValues.from} onChange={fromhandlechange} /></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>To Date</label>
                <Form.Control size="sm" type="date" style={mystyle} value={docEmpValues.to} onChange={tohandlechange} /></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>Branch Name</label>
                <Form.Select size="sm" style={mystyle} value={docEmpValues.branch} onChange={branchhandlechange}>
                  {details1.map(trns => (
                    <option value={trns.regionId}>{trns.regionalName}</option>
                  ))}
                </Form.Select></center>
              </Col>
              <Col><center>
                <label style={mystyle1}>Employee Name</label>
                <Form.Select size="sm" style={mystyle} value={docEmpValues.empnm} onChange={empnmhandlechange}>
                  {details2.map(trns => (
                    <option value={trns.employeeId}>{trns.employeeName}</option>
                  ))}
                </Form.Select></center>
              </Col>
            </Row>
            <Row className="mb-1 mt-2">
              <Col lg={4}></Col>
              <Col lg={4}>
                <Button variant="primary"style={{ fontFamily: 'Times New Roman'}} size="sm" onClick={showBtnOperations}> {showProcs ? 'processing...' : 'Show'} </Button>
                &nbsp;
                <Button variant="success"style={{ fontFamily: 'Times New Roman'}} size="sm" onClick={exportExcelBtn}> {exportExcelProcs ? 'processing...' : 'Export Excel'} </Button>
              </Col>
              <Col lg={4}></Col>
            </Row>
            <ItemPap1>
              <TableContainer sx={{ height: 420 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                      <StyledTableCell>Operation</StyledTableCell>
                      <StyledTableCell>JobNo{jobNoSrch()}</StyledTableCell>
                      <StyledTableCell>JobStatus</StyledTableCell>
                      <StyledTableCell>Branch</StyledTableCell>
                      <StyledTableCell>EDI_Location{ediLocSrch()}</StyledTableCell>
                      <StyledTableCell>CustomerName{cusNmSrch()}</StyledTableCell>
                      <StyledTableCell>ForwarderName</StyledTableCell>
                      <StyledTableCell>MAWB_Mbl_No</StyledTableCell>
                      <StyledTableCell>MAWB_Mbl_Date</StyledTableCell>
                      <StyledTableCell>HAWB_Mbl_No</StyledTableCell>
                      <StyledTableCell>HAWB_Mbl_Date</StyledTableCell>
                      <StyledTableCell>IGM_No{igmNoSrch()}</StyledTableCell>
                      <StyledTableCell>IGM_Date</StyledTableCell>
                      <StyledTableCell>Total_Pcs</StyledTableCell>
                      <StyledTableCell>Total_WT</StyledTableCell>
                      <StyledTableCell>BE_SB_Type</StyledTableCell>
                      <StyledTableCell>BE_SB_No</StyledTableCell>
                      <StyledTableCell>BE_SB_Date</StyledTableCell>
                      <StyledTableCell>No_Of_Invoice</StyledTableCell>
                      <StyledTableCell>Tot_Inv_Value</StyledTableCell>
                      <StyledTableCell>No_Of_Item</StyledTableCell>
                      <StyledTableCell>Assessible_Value</StyledTableCell>
                      <StyledTableCell>Duty_Amount</StyledTableCell>
                      <StyledTableCell>DrawBack_Amount</StyledTableCell>
                      <StyledTableCell>InvoiceCurrency</StyledTableCell>
                      <StyledTableCell>Job_Date</StyledTableCell>
                      <StyledTableCell>Job_By</StyledTableCell>
                      <StyledTableCell>Invoice_Date</StyledTableCell>
                      <StyledTableCell>Invoice_By</StyledTableCell>
                      <StyledTableCell>Item_Date</StyledTableCell>
                      <StyledTableCell>Item_By</StyledTableCell>
                      <StyledTableCell>CheckList_PrintDate</StyledTableCell>
                      <StyledTableCell>CheckList_PrintBy</StyledTableCell>
                      <StyledTableCell>CheckList_ApprovalDate</StyledTableCell>
                      <StyledTableCell>CheckList_ApprovalBy</StyledTableCell>
                      <StyledTableCell>CheckList_SendDate</StyledTableCell>
                      <StyledTableCell>CheckList_SendBy</StyledTableCell>
                      <StyledTableCell>CheckList_VerifyDate</StyledTableCell>
                      <StyledTableCell>CheckList_VerifyBy</StyledTableCell>
                      <StyledTableCell>CheckList_ApprovalBy</StyledTableCell>
                      <StyledTableCell>FlatFileGenerationDate</StyledTableCell>
                      <StyledTableCell>FlatFileGenerationBy</StyledTableCell>
                      <StyledTableCell>FlatFileICEGATEuploadDate</StyledTableCell>
                      <StyledTableCell>FlatFileICEGATEuploadBy</StyledTableCell>
                      <StyledTableCell>BE_SB_No_UpdatedDate</StyledTableCell>
                      <StyledTableCell>BE_SB_No_UpdatedBy</StyledTableCell>
                      <StyledTableCell>DutyPaymentDate</StyledTableCell>
                      <StyledTableCell>DutyPaymentBy</StyledTableCell>
                      <StyledTableCell>TSPaymentDate</StyledTableCell>
                      <StyledTableCell>TSPaymentBy</StyledTableCell>
                      <StyledTableCell>ClearanceDate</StyledTableCell>
                      <StyledTableCell>ClearanceBy</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((trns, index) => (
                        <TableRow hover key={trns.serialNumber}>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.operationType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.status}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.regionalName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.customPointName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.importer_name}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.forwarder_name}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.mawbNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.mawb_date}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawb_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawbDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igmNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igmDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalPcs}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalWeight}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.beType}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.boe_no}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.boe_date}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalInvoice}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceValue}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalCarton}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.assbleValue}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.dutyAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.drawbackAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.currency_code}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.jobDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.jobBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.itemDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.itemBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.clPrintDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.clPrintBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.clApprovalDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.clApprovalBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.clSendDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.clSendBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.clVerifyDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.clVerifyBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.flatGenDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.flatGenBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.flatIcegateDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.flatIcegateBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.beUpdatedDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.beUpdatedBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.dutyDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.dutyBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.tspDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.tspBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.clearanceDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.clearanceBy}</StyledTableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component='div'
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>}
      </div>
    </div>
  );
}

export default DocumentationEmployeeReport;
